import React, { useState, useEffect } from 'react';
import $i18n from '@/i18n';
import { Field } from '@alifd/next';
import { formatTime } from '@/utils';
import { tableColumons } from './config';
import Confirm from '@/components/Confirm';
import Button, { promisifyValidate } from '@/components/Button';
import Requests from '@/services/request';
import { getQueryStringArgs } from '@/utils/url-parse';
import DefaultAppIcon from '@/components/DefaultAppIcon';
import CalculateComponent from '@/components/CalculateComponent';
import { Icon, Timeline, Tag, Modal, Input, Form, Table } from '@b-design/fusion';
import './index.less';

interface App {
  approvalDetail: any;
  initDataSource: any;
  roleList: any;
}

interface IRecord {
  urlId: string;
  urlName: string;
  urls: string[];
  description: string;
}

interface IDataSource {
  list: IRecord[];
  total: number;
}

const RedirectUrl: React.FC<App> = ({ approvalDetail, initDataSource, roleList }) => {
  const [, setContentHeight] = useState(200);
  const field = Field.useField();
  const { init, getValue, getError } = field;
  const { approveId } = getQueryStringArgs();
  const [isRejectModalVisible, setIsRejectModalVisible] = useState(false);
  const [dataSource, setDataSource] = useState<IDataSource>({ list: [], total: 0 });

  useEffect(() => {
    const approveInfo = approvalDetail?.approveInfo;
    const list = approveInfo ? [approveInfo] : [];
    setDataSource({
      list,
      total: list.length,
    });
  }, [approvalDetail]);

  // 通过按钮
  const handleOk = async () => {
    const data = await Requests.post('/rest/intercnn/approve/process', {
      approveId,
      approveAction: 'PASSED',
      approveOpinion: 'PASSED',
    });
    if (data) {
      initDataSource();
    }
  };

  // 拒绝按钮
  const handleRejectOk = async () => {
    const [errs] = await promisifyValidate(field);
    if (errs) {
      return;
    }
    const data = await Requests.post('/rest/intercnn/approve/process', {
      approveId,
      approveAction: 'REJECT',
      approveOpinion: getValue('description'),
    });
    if (data) {
      setIsRejectModalVisible(false);
      initDataSource();
    }
  };

  return (
    <>
      <div className="redirect-url-approvals-details-table-container">
        <div className="table-header-title">
          {$i18n.get({
            id: 'aopf.pages.miniapp.version.info.process.Approvals.applyInfo',
            dm: '申请信息',
          })}
        </div>
        <div
          style={{
            position: 'relative',
            transition: 'all .3s',
            marginBottom: '16px',
          }}
        >
          <Table.StickyLock
            className="redirect-url-auth-table"
            primaryKey="urlId"
            columns={tableColumons}
            dataSource={dataSource?.list}
            fixedHeader
            hasBorder={false}
          />
        </div>
      </div>
      <div className="approvals-container">
        <div className="container-left">
          <div className="container-processTitle">
            {$i18n.get({
              id: 'aopf.pages.miniapp.version.info.process.Approvals.Process',
              dm: '审批流程',
            })}
          </div>
          <Timeline>
            <Timeline.Item
              title={
                <div className="progress-item">
                  <span>{approvalDetail?.createName}</span>
                  <span>{formatTime(approvalDetail?.gmtCreate)}</span>
                </div>
              }
              content={
                <div className="progress-content">
                  <div className="progress-dec">
                    {$i18n.get({
                      id: 'aopf.detail.redirectUrl.SubmitARequestForAn',
                      dm: '提交申请小程序跳转URL',
                    })}
                  </div>
                  <Tag data-square>
                    {$i18n.get({
                      id: 'aopf.pages.miniapp.version.info.process.Application',
                      dm: '申请',
                    })}
                  </Tag>
                  <span className="progress-content-text">
                    {$i18n.get({
                      id: 'aopf.detail.redirectUrl.ApplyForAnAppletJump',
                      dm: '申请小程序跳转 URL',
                    })}
                  </span>
                </div>
              }
            />

            {approvalDetail?.status !== 'PROCESSING' ? (
              <Timeline.Item
                title={
                  <div className="progress-item">
                    <span>{approvalDetail?.modifiedName}</span>
                    <span>{formatTime(approvalDetail?.gmtModified)}</span>
                  </div>
                }
                content={
                  <div className="progress-content">
                    {approvalDetail?.approveAction === 'PASSED' ? (
                      <div>
                        <div className="progress-dec">
                          {$i18n.get({
                            id: 'aopf.detail.redirectUrl.ReviewAppletJumpUrlApplication',
                            dm: '审查 小程序跳转URL申请',
                          })}
                        </div>
                        <Tag data-square data-tag-color="cold-green">
                          {$i18n.get({
                            id: 'aopf.pages.miniapp.version.info.process.Passed',
                            dm: '审批通过',
                          })}
                        </Tag>
                      </div>
                    ) : approvalDetail?.approveAction === 'WITHDRAW' ? (
                      <>
                        <div className="progress-dec">
                          {$i18n.get({
                            id: 'aopf.detail.redirectUrl.RevocationApplication',
                            dm: '撤销申请',
                          })}
                        </div>
                        <Tag data-square color="#FFF4ED" style={{ color: '#FF7E33' }}>
                          {$i18n.get({
                            id: 'aopf.pages.miniapp.version.info.process.Withdraw',
                            dm: '撤销',
                          })}
                        </Tag>
                      </>
                    ) : (
                      <>
                        <div className="progress-dec">
                          {$i18n.get({
                            id: 'aopf.detail.redirectUrl.ReviewAppletJumpUrlApplication',
                            dm: '审查 小程序跳转URL申请',
                          })}
                        </div>
                        <Tag data-square data-tag-color="red">
                          {$i18n.get({
                            id: 'aopf.pages.miniapp.version.info.process.Refused',
                            dm: '拒绝',
                          })}
                        </Tag>
                        <span className="progress-content-text">
                          {approvalDetail?.approveOpinion
                            ? approvalDetail?.approveOpinion
                            : $i18n.get({
                                id: 'aopf.pages.miniapp.version.info.process.No.Reason',
                                dm: '拒绝',
                              })}
                        </span>
                      </>
                    )}
                  </div>
                }
              />
            ) : (
              <></>
            )}
          </Timeline>
          {approvalDetail?.status === 'PROCESSING' && roleList.includes('ADMIN') && (
            <div className="progress-withdraw">
              <Confirm
                trigger={
                  <Button type="primary" style={{ marginRight: '16px' }}>
                    {$i18n.get({
                      id: 'aopf.approvals.datail.approve',
                      dm: '批准',
                    })}
                  </Button>
                }
                dialogTitle={$i18n.get({
                  id: 'aopf.detail.redirectUrl.ApprovalProcess',
                  dm: '审批流程',
                })}
                dialogContent={$i18n.get({
                  id: 'aopf.detail.redirectUrl.YouAreProcessingARequest',
                  dm: '您正在处理小程序跳转 URL 申请，是否批准？',
                })}
                onClick={handleOk}
              />

              <Button type="secondary" onClick={() => setIsRejectModalVisible(true)}>
                {$i18n.get({
                  id: 'aopf.approvals.datail.reject',
                  dm: '拒绝',
                })}
              </Button>
            </div>
          )}
        </div>

        <div className="container-right" style={{ position: 'relative' }}>
          {approvalDetail?.extInfo?.description?.iconPublicUrl ? (
            <img className="logo" src={approvalDetail?.extInfo?.description?.iconPublicUrl} />
          ) : (
            <DefaultAppIcon className="logo" />
          )}

          <div className="right-appInfo">
            {$i18n.get({
              id: 'aopf.pages.miniapp.version.info.App.information',
              dm: '应用程序信息',
            })}
          </div>
          <div className="right-content">
            <div className="right-icon">
              <Icon type="mobile--outline" size="xs" />
            </div>
            <div className="right-title">
              {$i18n.get({
                id: 'aopf.pages.miniapp.version.info.Miniapp.Name',
                dm: 'Miniapp名称',
              })}
            </div>
            <div className="left-context">{approvalDetail?.extInfo?.description?.name}</div>
          </div>

          <div className="right-content">
            <div className="right-icon">
              <Icon type="apps--outline" size="xs" />
            </div>
            <div className="right-title">
              {$i18n.get({
                id: 'aopf.pages.miniapp.version.info.Type',
                dm: '类型',
              })}
            </div>
            <div className="left-context">{approvalDetail?.extInfo?.app?.framework}</div>
          </div>

          <div className="right-content">
            <div className="right-icon">
              <Icon type="user--outline" size="xs" />
            </div>
            <div className="right-title">
              {$i18n.get({
                id: 'aopf.pages.miniapp.version.info.process.Creator',
                dm: '作者',
              })}
            </div>
            <div className="left-context">{approvalDetail?.extInfo?.description?.createName}</div>
          </div>

          <div className="right-content">
            <div className="right-icon">
              <Icon type="wikis--outline" size="xs" />
            </div>
            <div className="right-title">
              {$i18n.get({
                id: 'aopf.pages.miniapp.version.info.Slogan',
                dm: '标语',
              })}
            </div>
            <div className="left-context">{approvalDetail?.extInfo?.description?.slogan}</div>
          </div>

          <div className="right-content">
            <div className="right-icon">
              <Icon type="document--outline" size="xs" />
            </div>
            <div className="right-title">
              {$i18n.get({
                id: 'aopf.pages.miniapp.version.info.Description',
                dm: '描述',
              })}
            </div>
            <div className="left-context">{approvalDetail?.extInfo?.description?.description}</div>
          </div>
        </div>
        <Modal
          title={$i18n.get({
            id: 'aopf.pages.approvals.version.info.process.reject',
            dm: '拒绝申请',
          })}
          visible={isRejectModalVisible}
          onCancel={() => setIsRejectModalVisible(false)}
          closeMode={['close', 'esc', 'mask']}
          onClose={() => setIsRejectModalVisible(false)}
          footer={
            <div>
              <Button onClick={() => setIsRejectModalVisible(false)}>
                {$i18n.get({
                  id: 'aopf.pages.approvals.version.info.confirm.Cancel',
                  dm: '取消',
                })}
              </Button>
              <Button type="primary" onClick={handleRejectOk} style={{ marginLeft: '8px' }}>
                {$i18n.get({
                  id: 'aopf.pages.approvals.version.info.confirm.Ok',
                  dm: '确定',
                })}
              </Button>
            </div>
          }
        >
          <div
            style={{
              marginTop: '20px',
              width: '500px',
              fontSize: '14px',
              letterSpacing: '0.47px',
              lineHeight: '20px',
              fontWeight: '400',
            }}
          >
            <Form>
              <Form.Item
                name="description"
                label={$i18n.get({ id: 'aopf.pages.approvals.form.title.description', dm: '描述' })}
              >
                <Input.TextArea
                  placeholder={$i18n.get({
                    id: 'aopf.pages.approvals.form.Description.placeholder',
                    dm: '输入2-200个字符的描述',
                  })}
                  autoHeight={{ minRows: 4, maxRows: 8 }}
                  style={{ width: '470px' }}
                  {...init('description', {
                    initValue: '',
                    rules: {
                      required: true,
                      minLength: 2,
                      maxLength: 200,
                      message: $i18n.get({
                        id: 'aopf.pages.approvals.form.Description.placeholder',
                        dm: '输入2-200个字符的描述',
                      }),
                    },
                  })}
                  showLimitHint
                  maxLength={200}
                />

                <p style={{ fontSize: 12, color: '#c82727' }}>{getError('description')}</p>
              </Form.Item>
            </Form>
          </div>
        </Modal>
      </div>
      <CalculateComponent
        otherWidth={280}
        otherHeight={0}
        windowChange={(_width, height) => {
          setContentHeight(height);
        }}
      />
    </>
  );
};
export default RedirectUrl;
